import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Input, Modal } from 'antd';
import { CopyOutlined } from '@ant-design/icons';
import { useGetTripTasks } from 'api/trip-task/use-get-trip-tasks';
import { useCopyToClipboard } from 'shared/hooks/use-copy-to-clipboard';
import type { ITripSetTaskModalProps } from './types';

export const TripSetTaskModal: React.FC<ITripSetTaskModalProps> = (props) => {
  const { isModalVisible, handleClose, trip } = props;
  const { data: tripTasks } = useGetTripTasks({ tripId: trip.id });

  const { t } = useTranslation();
  const [taskTemplates, setTaskTemplates] = useState('');

  const copyToClipboard = useCopyToClipboard();

  useEffect(() => {
    if (!isModalVisible) return;

    const comments =
      tripTasks
        ?.map((task) => task.comments)
        .filter(Boolean)
        .join('\n\n') ?? '';

    setTaskTemplates(comments);
  }, [isModalVisible, tripTasks]);

  const handleTextChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setTaskTemplates(e.target.value);
  };

  return (
    <Modal
      title={t('trip:driver_tasks')}
      open={isModalVisible}
      footer={[
        <Button key='copy' icon={<CopyOutlined />} onClick={() => copyToClipboard(taskTemplates)}>
          {t('common:copy')}
        </Button>,
      ]}
      onCancel={handleClose}>
      <Input.TextArea value={taskTemplates} rows={10} onChange={handleTextChange} />
    </Modal>
  );
};
